/**
 * External dependencies
 */
import {__} from '@wordpress/i18n';

export default {
  placeholder: {
    type: 'string',
    default: __('Search products...', 'yith-woocommerce-ajax-search'),
  },
  placeholderTextColor: {
    type: 'string',
    default: '#000',
  },
  iconType: {
    type: 'string',
    default: 'icon-right',
  },
  inputTextColor: {
    type: 'string',
    default: '#000',
  },
  inputBgColor: {
    type: 'string',
    default: '#fff',
  },
  inputBgFocusColor: {
    type: 'string',
    default: '#fff',
  },
  inputBorderColor: {
    type: 'string',
    default: '#7C7C7C',
  },
  inputBorderFocusColor: {
    type: 'string',
    default: '#5B5B5B',
  },
  inputBorderSize: {
    type: 'object',
    default: {
      topLeft: "1px",
      topRight: "1px",
      bottomLeft: "1px",
      bottomRight: "1px"
    }
  },
  inputBorderRadius: {
    type: 'object',
    default: {
      topLeft: "20px",
      topRight: "20px",
      bottomLeft: "20px",
      bottomRight: "20px"
    }
  },
  submitContentColor: {
    type: 'string',
    default: '#000',
  },
  submitContentHoverColor: {
    type: 'string',
    default: '#000',
  },
  submitBorderColor: {
    type: 'string',
    default: '#fff',
  },
  submitBorderHoverColor: {
    type: 'string',
    default: '#fff',
  },
  submitBgColor: {
    type: 'string',
    default: '#fff',
  },
  submitBgHoverColor: {
    type: 'string',
    default: '#fff',
  },
  submitStyle: {
    type: 'string',
    default: 'icon',
  },
  className: {
    type: 'string',
    default: 'ywcas-input-block',
  },
  buttonLabel: {
    type: 'string',
    default: __('Search', 'yith-woocommerce-ajax-search-premium'),
  },
  buttonBorderRadius: {
    type: 'object',
    default: {
      topLeft: "10px",
      topRight: "10px",
      bottomLeft: "10px",
      bottomRight: "10px"
    }
  },
  lock: {
    type: 'object',
    default: {
      remove: false,
      move: false,
    },
  },
};
